import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Phone, Mail, MapPin, FileText, BookOpen } from 'lucide-react';

export default function PortalLayout({ children }) {
  return (
    <div className="min-h-screen bg-slate-50 flex flex-col">
      {/* Header */}
      <header className="bg-white border-b border-slate-200 sticky top-0 z-50">
        <div className="max-w-6xl mx-auto px-4 h-16 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2">
            <img src="/logo-icon.svg" alt="Tinkle Tent" className="h-10 w-10" />
            <div className="flex flex-col">
              <span className="font-bold text-[#194461] text-lg leading-none">Tinkle Tent</span>
              <span className="text-xs text-slate-500 leading-none -mt-0.5">Rentals</span>
            </div>
          </Link>
          <nav className="flex items-center gap-4">
            <a 
              href="/sales-sheet.html" 
              target="_blank" 
              rel="noopener noreferrer"
              className="hidden sm:flex items-center gap-1.5 text-sm text-slate-600 hover:text-[#194461] transition-colors"
              data-testid="nav-sales-sheet"
            >
              <FileText size={16} />
              Sales Sheet
            </a>
            <a 
              href="/demo-guide.html" 
              target="_blank" 
              rel="noopener noreferrer"
              className="hidden sm:flex items-center gap-1.5 text-sm text-slate-600 hover:text-[#194461] transition-colors"
              data-testid="nav-demo-guide"
            >
              <BookOpen size={16} />
              Demo Guide
            </a>
            <Link to="/portal/my-rentals">
              <Button variant="ghost" size="sm" data-testid="nav-my-rentals">
                My Rentals
              </Button>
            </Link>
            <Link to="/portal/request-quote">
              <Button 
                className="bg-[#194461] hover:bg-[#091D2E] text-white"
                size="sm"
                data-testid="nav-request-quote"
              >
                Request a Quote
              </Button>
            </Link>
          </nav>
        </div>
      </header>

      {/* Main content */}
      <main className="flex-1">
        {children}
      </main>

      {/* Footer */}
      <footer className="bg-[#091D2E] text-white py-12">
        <div className="max-w-6xl mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {/* Company Info */}
            <div>
              <div className="flex items-center gap-3 mb-4">
                <img src="/logo-icon.svg" alt="Tinkle Tent" className="h-12 w-12 brightness-0 invert" />
                <div className="flex flex-col">
                  <span className="font-bold text-white text-xl leading-none">Tinkle Tent</span>
                  <span className="text-sm text-slate-400 leading-none -mt-0.5">Rentals</span>
                </div>
              </div>
              <p className="text-slate-300 text-sm">
                Professional portable toilet rentals serving Johnson City, TN and the surrounding Tri-Cities area.
              </p>
            </div>

            {/* Contact */}
            <div>
              <h3 className="font-semibold text-lg mb-4">Contact Us</h3>
              <div className="space-y-3 text-sm text-slate-300">
                <div className="flex items-center gap-2">
                  <Phone size={16} />
                  <span>(423) 555-0100</span>
                </div>
                <div className="flex items-center gap-2">
                  <Mail size={16} />
                  <span>info@tinkletent.com</span>
                </div>
                <div className="flex items-center gap-2">
                  <MapPin size={16} />
                  <span>Johnson City, TN 37601</span>
                </div>
              </div>
            </div>

            {/* Quick Links */}
            <div>
              <h3 className="font-semibold text-lg mb-4">Quick Links</h3>
              <div className="space-y-2 text-sm">
                <Link to="/portal/request-quote" className="block text-slate-300 hover:text-white transition-colors">
                  Request a Quote
                </Link>
                <Link to="/portal/my-rentals" className="block text-slate-300 hover:text-white transition-colors">
                  My Rentals
                </Link>
                <Link to="/portal/request-service" className="block text-slate-300 hover:text-white transition-colors">
                  Request Extra Service
                </Link>
              </div>
            </div>
          </div>

          <div className="mt-8 pt-8 border-t border-slate-700 text-center text-sm text-slate-400">
            © {new Date().getFullYear()} Tinkle Tent Rentals. All rights reserved.
          </div>
        </div>
      </footer>
    </div>
  );
}
